var map = {
	"./de-DE/dataset-settings": 9175,
	"./en-US/dataset-settings": 48810,
	"./es-ES/dataset-settings": 41577,
	"./fa-IR/dataset-settings": 7105,
	"./fr-FR/dataset-settings": 54429,
	"./hi-IN/dataset-settings": 52599,
	"./it-IT/dataset-settings": 42383,
	"./ja-JP/dataset-settings": 94106,
	"./ko-KR/dataset-settings": 5228,
	"./pl-PL/dataset-settings": 61129,
	"./pt-BR/dataset-settings": 8545,
	"./ro-RO/dataset-settings": 58895,
	"./ru-RU/dataset-settings": 55003,
	"./sl-SI/dataset-settings": 57650,
	"./th-TH/dataset-settings": 36721,
	"./tr-TR/dataset-settings": 86033,
	"./uk-UA/dataset-settings": 11391,
	"./vi-VN/dataset-settings": 94072,
	"./zh-Hans/dataset-settings": 67547,
	"./zh-Hant/dataset-settings": 39032
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32621;